/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Shipping_Carrier_Not_FoundInputs */

const vi_error_shipping_carrier_not_found = /** @type {(inputs: Error_Shipping_Carrier_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhà vận chuyển không tồn tại hoặc đã bị xoá. Vui lòng chọn lại nhà vận chuyển.`)
};

/**

* @param {Error_Shipping_Carrier_Not_FoundInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shipping_carrier_not_found = /** @type {((inputs?: Error_Shipping_Carrier_Not_FoundInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shipping_Carrier_Not_FoundInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shipping_carrier_not_found(inputs)
});